import { API_URL } from '../config/config';
import { getRequest, patchRequest } from '../utils/axiosUtils';
import buildQueryParams from '../utils/buildQueryParams';

export const fetchSupportData = async (setUserData, page, limit, skip,filter) => {
  const { utm_payload,dateRange,statsType } = filter;
  const queryParams = buildQueryParams({
    page,
    limit,
    skip,
    utm_payload,
    dateRange,
    statsType
  });

  const res = await getRequest({
    url: `${API_URL}/admin/support/all?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    setUserData(res.data.data);
    return res.data.pagination;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const updateSupportStatus = async ({ supportId, status }) => {
  const res = await patchRequest({
    url: `${API_URL}/admin/support/update/${supportId}`,
    data: { status }
  });

  if (res.status >= 200 && res.status < 300) {
    return true;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
